import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import StarRoundedIcon from '@material-ui/icons/StarRounded';
import yellow from '@material-ui/core/colors/yellow';
import { SvgIconProps } from '@material-ui/core/SvgIcon/SvgIcon';

export type StarIconProps = SvgIconProps & { checked?: boolean };

const StarIcon: React.FC<StarIconProps> = withStyles((theme) => ({
  root: {
    stroke: theme.palette.common.white,
    strokeWidth: 2,
    color: (props) => (props.checked ? yellow[700] : theme.palette.grey[500]),
    fontSize: 32,
  },
}))(StarRoundedIcon);

export default StarIcon;
